import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ReportsApi = createApi({
  reducerPath: "NewReports",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/reports`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getVehicleTrips: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/trips?from=${startdate}&to=${enddate}&${ids}&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getVehicleRoutes: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/route?from=${startdate}&to=${enddate}&${ids}&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getSummaryReports: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        selectedgroups: groupid,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/summary?from=${startdate}&to=${enddate}&${ids}${
          groupid ? `&${groupid}` : ""
        }&daily=true&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getStopReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/stops?from=${startdate}&to=${enddate}&${ids}&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getFuelReports: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        selectedgroups: groupid,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/summary?from=${startdate}&to=${enddate}&${ids}${
          groupid ? `&${groupid}` : ""
        }&daily=true&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
  }),
});

export const {
  useGetVehicleTripsQuery,
  useLazyGetVehicleTripsQuery,
  useGetVehicleRoutesQuery,
  useLazyGetVehicleRoutesQuery,
  useGetStopReportQuery,
  useLazyGetStopReportQuery,
  useLazyGetSummaryReportsQuery,
  useGetSummaryReportsQuery,
  useLazyGetFuelReportsQuery,
} = ReportsApi;
